import { useSupportedLanguagesContext } from 'containers/SupportedLanguagesContainer/SupportedLanguagesContext';
import i18n from 'i18n';
import { useMemo } from 'react';

interface LanguageCode {
  azure: string;
  snow: string;
}

const defaultLanguageCode: LanguageCode = {
  azure: 'en',
  snow: 'en',
};

export const useLanguageCode = () => {
  const { languageOptions } = useSupportedLanguagesContext();

  const languageCodes = useMemo(() => {
    return languageOptions.reduce((codes, language) => {
      codes[language.code] = {
        azure: language.code,
        snow: language.snowCode ?? language.code,
      };
      return codes;
    }, {} as Record<string, LanguageCode>);
  }, [languageOptions]);

  return languageCodes[i18n.language] ?? defaultLanguageCode;
};
